import { render, staticRenderFns } from "./DokmanComponentPruefungAktualisieren.vue?vue&type=template&id=160bebd6&scoped=true"
import script from "./DokmanComponentPruefungAktualisieren.vue?vue&type=script&lang=js"
export * from "./DokmanComponentPruefungAktualisieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160bebd6",
  null
  
)

export default component.exports